import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Typography,
} from "@mui/material";

import "./layout.css";
import img from "../../assets/images/Image.png";
import shield from "../../assets/images/sidebarImages/shield.svg";
import linkLogo from "../../assets/images/sidebarImages/link.svg";
import briefcase from "../../assets/images/sidebarImages/briefcase.svg";
import world from "../../assets/images/sidebarImages/world.svg";
// import flag3 from "../../assets/images/sidebarImages/flag3.svg";
import clipboardText from "../../assets/images/sidebarImages/clipboardText.svg";
import plane from "../../assets/images/sidebarImages/plane.svg";
import userStar from "../../assets/images/sidebarImages/userStar.svg";
import database from "../../assets/images/sidebarImages/database.svg";
import clipboardCheck from "../../assets/images/sidebarImages/clipboardCheck.svg";
import mailCheck from "../../assets/images/sidebarImages/mailCheck.svg";
import notebook from "../../assets/images/sidebarImages/notebook.svg";
import moneybag from "../../assets/images/sidebarImages/moneybag.svg";
import motorbike from "../../assets/images/sidebarImages/motorbike.svg";
import userCog from "../../assets/images/sidebarImages/userCog.svg";
import footsteps from "../../assets/images/sidebarImages/footsteps.svg";
import currencyCoin from "../../assets/images/sidebarImages/currencyCoin.svg";
import helmet from "../../assets/images/sidebarImages/helmet.svg";
import CAETool from "../../assets/images/sidebarImages/CAETool.svg";
import SSDTool from "../../assets/images/sidebarImages/SDD Tool.svg";
import bilogo from "../../assets/images/sidebarImages/powerbilogo.svg";
import { useAppSelector } from "../../globalState/hooks";
import { LoginRootState } from "../../types/login";

const SidebarSection: React.FC = () => {
  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials,
  );
  const excludedDesignations = ["Associate Engineer", "Intern"];
  const isExcludedDesignation = excludedDesignations.includes(
    userDetails?.designation,
  );
  const menuItems = [
    { text: "Policies", logo: shield, path: "/policies" },
    {
      text: "RE Link",
      logo: linkLogo,
      path: "https://performancemanager10.successfactors.com/sf/home?bplte_company=C0001163367P&_s.crb=2cnMDi%2bzdD40Me9%2fnga5p2fFNJ8%3d",
    },
    ...(userDetails.country !== "UK"
      ? [
          {
            text: "RE Worklife(AE)",
            logo: briefcase,
            path: "https://rehris.peoplestrong.com/secureSloginRedirect.jsf?idp=Okta&organizationId=383",
          },
        ]
      : []),
    ...(userDetails.employeeCategory === "Staff & Executives"
      ? [
          {
            text: "RE Accelerate",
            logo: helmet,
            path: "https://learningmanagereu.adobe.com/12803",
          },
        ]
      : []),
    ...(userDetails?.isRECompliance
      ? [
          {
            text: "RE Compliance (New)",
            logo: helmet,
            path: "https://eichermotors.complianceinsights.pwc.in/login",
          },
        ]
      : []),
    ...(userDetails?.country === "UK"
      ? [
          {
            text: "Neeyamo",
            logo: linkLogo,
            path: "https://onelogin.neeyamo.com/realms/enfield/protocol/openid-connect/auth?response_type=code&client_id=neosuite-client&state=YkRIUU13OGdFd25JT0t0YXZERGNiNFVrbEd1fjROaUladU1ndHZZZzBMcnRQ%3B%252Fhome&redirect_uri=https%3A%2F%2Fenfield.neosuite.neeyamo.com&scope=openid%20profile%20email&code_challenge=tmqL8bR611vF_8IsrYhwS-M7S9A6hJWTCJivZfvYgSY&code_challenge_method=S256&nonce=YkRIUU13OGdFd25JT0t0YXZERGNiNFVrbEd1fjROaUladU1ndHZZZzBMcnRQ",
          },
        ]
      : []),
    {
      text: "RE Analytics (COE)",
      logo: bilogo,
      path: " https://app.powerbi.com/groups/ff42a161-bafe-4922-aea7-30ae4e06ffd5/orgapps/2bd52a9b-7fa0-43b1-9b55-4a92b9ad4704?experience=power-bi",
    },
    {
      text: "Global IT Support",
      logo: world,
      path: "https://royalenfield.okta.com/home/royalenfield_manageengine_1/0oap6w3lwzpxiDvq02p7/alnp6wp12vRL8fWzi2p7",
    },
    {
      text: "Celebrate Budget",
      logo: currencyCoin,
      path: "http://claims.royalenfield.com/mycorner/nonlimit/Pages/home.aspx",
    },
    ...(userDetails.country === "UK"
      ? [
          {
            text: "FCM Travel Portal",
            logo: plane,
            path: "https://app.fcmtravel.com/login",
          },
        ]
      : []),
    {
      text: "Footsteps",
      logo: footsteps,
      path: "https://drive.google.com/drive/folders/1hXzshrHNeQZWD2Ir7hqMh5VGvOjJrnKm?usp=sharing",
    },
    {
      text: "Admin SPOC Details",
      logo: userCog,
      path: "https://drive.google.com/file/d/1udahcU2b3Xq3lXRfWSwnOwnRDCTvEQIT/preview",
    },
    {
      text: "RE CRA",
      logo: motorbike,
      path: "http://claims.royalenfield.com/mycorner/recra/Pages/home.aspx",
    },
    {
      text: "Provident Funds",
      logo: moneybag,
      path: "https://retrust.royalenfield.com",
    },
    {
      text: "Litigation Diary",
      logo: notebook,
      path: "https://royalenfield.okta.com/home/royalenfield_legaldiary_1/0oa8g3uxpgnCjzfoD2p6/aln8geewbhe8Nohf92p6",
    },
    {
      text: "Generic Email Access",
      logo: mailCheck,
      path: "https://royalenfield.okta.com/login/default",
    },
    {
      text: "RE Compliance",
      logo: clipboardCheck,
      path: "http://recompliance.royalenfield.com/",
    },
    {
      text: "RE Data",
      logo: database,
      path: "https://drive.google.com/drive/u/0/folders/0Bw-qQ-hPcq3_eGpFbVc3YVFLODg",
    },
    {
      text: "Employee Directory",
      logo: userStar,
      disabled: false,
      path: "https://performancemanager10.successfactors.com/sf/directory?bplte_company=C0001163367P&_s.crb=Nu2qKrpnMIl8G2IlGdCqUFgzp0k%3d",
    },
    ...(userDetails.isSSDUser
      ? [
          {
            text: "SEBI UPSI (SDD)",
            logo: SSDTool,
            path: "https://upsi.royalenfield.com/upsi-declaration",
          },
        ]
      : []),
    {
      text: "CAE Tools",
      logo: CAETool,
      disabled: false,
      path: "https://royalenfield.okta.com/home/royalenfield_caetools_1/0oazh3rpfmwQ6Rjyz2p7/alnzh3woyhGdJ57qd2p7",
    },
    // {
    //   text: "Travel Booking",
    //   disabled: true,
    //   logo: plane,
    //   path: "https://royalenfield.okta.com/home/royalenfield_thomascook_1/0oa16rkg8T1Nv95Oy2p6/aln16tsdsD4zIzYYg2p6",
    // },
    {
      text: "RE Forms",
      logo: clipboardText,
      path: "https://reforms.royalenfield.com/",
      disabled: false,
    },
    // {
    //   text: "RE Forms Reports",
    //   logo: flag3,
    //   disabled: true,
    //   path: "/re-forms-reports",
    // },
    ...(userDetails.country === "UK"
      ? [
          {
            text: "Fyle",
            logo: currencyCoin,
            path: "https://app.fylehq.com/app/accounts/#/signin",
          },
          {
            text: "Vialto (epay)",
            logo: briefcase,
            path: "https://www.myepaywindow.com/",
          },
        ]
      : []),
  ];
  const menuItemsForAE = [
    { text: "Policies", logo: shield, path: "/policies" },
    ...(userDetails.country !== "UK"
      ? [
          {
            text: "RE Worklife(AE)",
            logo: briefcase,
            path: "https://rehris.peoplestrong.com/secureSloginRedirect.jsf?idp=Okta&organizationId=383",
          },
        ]
      : []),
    {
      text: "Global IT Support",
      logo: world,
      path: "https://royalenfield.okta.com/home/royalenfield_manageengine_1/0oap6w3lwzpxiDvq02p7/alnp6wp12vRL8fWzi2p7",
    },
    {
      text: "Celebrate Budget",
      logo: currencyCoin,
      path: "http://claims.royalenfield.com/mycorner/nonlimit/Pages/home.aspx",
    },
    {
      text: "Footsteps",
      logo: footsteps,
      path: "https://drive.google.com/drive/folders/1hXzshrHNeQZWD2Ir7hqMh5VGvOjJrnKm?usp=sharing",
    },
    {
      text: "Admin SPOC Details",
      logo: userCog,
      path: "https://drive.google.com/file/d/1ot3NSQQkLXIz-0fnp99c5aXFU1OmEsOk/view?usp=drive_link",
    },
    {
      text: "RE CRA",
      logo: motorbike,
      path: "http://claims.royalenfield.com/mycorner/recra/Pages/home.aspx",
    },
    {
      text: "Provident Funds",
      logo: moneybag,
      path: "https://retrust.royalenfield.com",
    },
    {
      text: "Litigation Diary",
      logo: notebook,
      path: "https://royalenfield.okta.com/home/royalenfield_legaldiary_1/0oa8g3uxpgnCjzfoD2p6/aln8geewbhe8Nohf92p6",
    },
    {
      text: "Generic Email Access",
      logo: mailCheck,
      path: "https://royalenfield.okta.com/login/default",
    },
    {
      text: "RE Compliance",
      logo: clipboardCheck,
      path: "http://recompliance.royalenfield.com/",
    },

    // {
    //   text: "RE Data",
    //   logo: database,
    //   path: "https://drive.google.com/drive/u/0/folders/0Bw-qQ-hPcq3_eGpFbVc3YVFLODg",
    // },
    {
      text: "Employee Directory",
      logo: userStar,
      disabled: false,
      path: "https://performancemanager10.successfactors.com/sf/directory?bplte_company=C0001163367P&_s.crb=Nu2qKrpnMIl8G2IlGdCqUFgzp0k%3d",
    },
    {
      text: "CAE Tools",
      logo: CAETool,
      disabled: false,
      path: "https://royalenfield.okta.com/home/royalenfield_caetools_1/0oazh3rpfmwQ6Rjyz2p7/alnzh3woyhGdJ57qd2p7",
    },
    {
      text: "RE Forms",
      logo: clipboardText,
      path: "https://reforms.royalenfield.com/",
      disabled: false,
    },
    // {
    //   text: "RE Forms Reports",
    //   logo: flag3,
    //   disabled: true,
    //   path: "/re-forms-reports",
    // },
    ...(userDetails.country === "UK"
      ? [
          {
            text: "Fyle",
            logo: currencyCoin,
            path: "https://app.fylehq.com/app/accounts/#/signin",
          },
          {
            text: "Vialto (epay)",
            logo: briefcase,
            path: "https://www.myepaywindow.com",
          },
        ]
      : []),
  ];
  const menuItemsForIntern = [
    { text: "Policies", logo: shield, path: "/policies" },
    {
      text: "Admin SPOC Details",
      logo: userCog,
      disabled: false,
      path: "https://drive.google.com/file/d/1ot3NSQQkLXIz-0fnp99c5aXFU1OmEsOk/view?usp=drive_link",
    },
  ];
  return (
    <Box
      sx={{
        width: 260,
        backgroundColor: "#393939",
        height: "100vh",
        boxShadow: "2px 0px 10px rgba(0,0,0,0.1)",
      }}
    >
      {/* Profile Section */}
      <Box
        sx={{
          backgroundColor: "#212121",
          padding: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            backgroundColor: "#ddd",
          }}
        >
          <Avatar
            src={userDetails.photoUrl ? userDetails.photoUrl : img}
            alt="User Profile"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
        <Box sx={{ marginLeft: 2 }}>
          <Typography className="f-16" color="#fff" fontWeight={600}>
            {userDetails.fullName.length > 20
              ? userDetails.fullName.substr(0, 20).concat("...")
              : userDetails.fullName}
          </Typography>
          {!isExcludedDesignation && userDetails?.department && (
            <Typography className="f-12" color="#fff">
              {userDetails.department.length > 22
                ? userDetails.department.substr(0, 22).concat("...")
                : userDetails.department}
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          overflowY: "scroll",
          height: "86vh",
          backgroundColor: "#393939",
        }}
      >
        <List sx={{ background: "#393939" }}>
          {(userDetails.designation === "Intern"
            ? menuItemsForIntern
            : ["Associate Engineer", "Testing Engineer"].includes(
                  userDetails.designation,
                )
              ? menuItemsForAE
              : menuItems
          ).map((item, index) => (
            <ListItem
              key={index}
              className="sidebar__item"
              sx={{
                borderRadius: "8px",
                opacity: item.disabled ? 0.5 : 1,
                pointerEvents: item.disabled ? "none" : "auto",
                "&:hover": {
                  backgroundColor: "#E6E6E6",
                  transition: "background-color 0.3s ease",
                },
              }}
            >
              <a
                href={item.path}
                target="blank"
                style={{
                  textDecoration: "none",
                  color: "#ffffff",
                  // background: "#393939",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  padding: "5px 16px",
                  cursor: item.disabled ? "not-allowed !important" : "pointer",
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <img
                    src={item.logo}
                    alt={item.text}
                    className="svg-icon"
                    style={{ width: 24, height: 24 }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  className="sidebar__text f-14"
                />
              </a>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default SidebarSection;
